import React, { Fragment } from 'react'
import firebase from 'firebase/app'

import useAuthentication from 'logic/authentication/auth.hook'

const AuthWatcher = ({ children }) => {
    const { authenticatedNo, authenticatedYes } = useAuthentication()

    // Register the listener on firebase.auth state
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            // User is signed in.
            authenticatedYes()
        } else {
            // No user is signed in.
            authenticatedNo()
        }
    })
    return <Fragment>{children}</Fragment>
}

export default AuthWatcher
